// extracted by mini-css-extract-plugin
export default {"title":"RequestsKanbanHeader_title__tprUn","line":"RequestsKanbanHeader_line__Wqr+X"};